import { render, staticRenderFns } from "./PasswordRecoverySuccess.vue?vue&type=template&id=4c59c996&scoped=true"
import script from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js"
export * from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoverySuccess.vue?vue&type=style&index=0&id=4c59c996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c59c996",
  null
  
)

export default component.exports